import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const ExternalRedirect = ({ to }) => {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
};
import Header from './components/Header';
import HomePage from './pages/HomePage';
import AccountDeletionRequest from './pages/AccountDeletion';
import SupportTicket from './pages/SupportTicket';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apple" element={<ExternalRedirect to="https://testflight.apple.com/join/5rc2tDZ7" />} />
            <Route path="/android" element={<ExternalRedirect to="https://play.google.com/store/apps/details?id=com.lumida.ai" />} />
            <Route path="/account-deletion" element={<AccountDeletionRequest />} />
            <Route path="/support" element={<SupportTicket />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms-condition" element={<TermsAndConditions />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
